export const CHAT_NAME = "chat";
export enum ChatComponents {
  ChatFab = "ChatFab",
  // Keep adding component names for style overrides
}
